import gql from 'graphql-tag';

export const DONATION_STORES = gql`
  query donationStores { donationStores { id name } }
`;

export const SUBMIT_DONATION = gql`
  mutation submitDonation($data: DonationInput!, $file: Upload) {
    submitDonation(data: $data, file: $file) {
      success
      errors { field message }
    }
  }
`;
